export const isDevEnv = () => {
    const hostname = window.location.hostname;
    return (process.env.NODE_ENV === 'development' || !!hostname.match(/^\w+-team\./));
};
//# sourceMappingURL=isDevEnv.js.map